<div class="rrhh-remove-agent-container">
  <!-- SECCIÓN BAJA RMX -->
  <div class="form-remove-agent" *ngIf="!isLoading">
    <ng-container *ngIf="!this.value.onlyQR">
      <div
        class="content-box rmx"
        *ngIf="!isLoading && visibleFormRMX && !successAgentRemoveRMX"
      >
        <h3 class="heading-02-semi-bold">
          ¿Desea solicitar la baja a RMX de {{ agentFullName }}?
        </h3>
        <!-- FORMULARIO BAJA RMX-->
        <div class="removal-rmx">
          <div class="left">
            <h4 class="subheading-01-semi-bold">Motivo</h4>
            <div class="dropdown-container">
              <qr-dropdown
                [config]="dropdown"
                (change)="dropdownChange($event)"
              ></qr-dropdown>
            </div>
            <ng-container *ngIf="visibleDetailTextarea">
              <h4 class="subheading-01-semi-bold detail-label">Detalles</h4>
              <textarea
                name=""
                id=""
                cols="30"
                rows="10"
                placeholder="Describa el motivo..."
                [(ngModel)]="textareaValue"
                (ngModelChange)="onTextareaChange($event)"
              ></textarea>
            </ng-container>
          </div>
          <div class="right">
            <input
              hidden
              type="file"
              multiple="false"
              #uploader
              (change)="addFile($event)"
            />
            <qr-button
              class="add-button"
              [config]="buttonAddFile"
              *ngIf="!uploadedFile"
              (click)="uploader.click()"
            ></qr-button>
            <div class="uploaded-file" *ngIf="uploadedFile">
              <qr-icon name="document" color="grey-500"></qr-icon>
              <span class="caption-01-regular" [matTooltip]="fileName">{{
                fileName
              }}</span>
              <qr-button
                [config]="buttonDeleteFile"
                [isDisabled]="true"
                (click)="deleteFile()"
                matTooltip="Eliminar archivo"
              ></qr-button>
            </div>
            <p
              class="paragraph-03-regular file-msg"
              *ngIf="fileWarning"
              [ngClass]="{
                error:
                  fileWarning == FILE_ERROR_SIZE ||
                  fileWarning == FILE_ERROR_TYPE
              }"
            >
              {{ fileWarning }}
            </p>
          </div>
        </div>
        <div class="buttons">
          <qr-button
            [config]="buttonAceptRemoveRMX"
            (click)="onAgentRemoveRMX()"
            [isDisabled]="disabledButtonRemoveRMX"
          ></qr-button>
        </div>
      </div>
    </ng-container>

    <!-- SUCCESS BAJA RMX ✅ -->
    <ng-container *ngIf="!this.value.onlyQR">
      <div
        class="success-remove"
        *ngIf="!visibleFormRMX && successAgentRemoveRMX"
      >
        <div class="sign-success">
          <qr-icon name="check" color="success-500"></qr-icon>
          <span class="subheading-01-semi-bold"
            >Se ha solicitado correctamente la baja del agente
            {{ agentFullName }} en RMX</span
          >
        </div>
      </div>
    </ng-container>

    <!-- SECCIÓN BAJA QR -->
    <div
      class="content-box qr"
      [ngClass]="{ disabled: !qrStatusActive }"
      *ngIf="visibleSectionRemoveQR && !successAgentRemoveQR"
    >
      <div class="line" *ngIf="!isLoading && !this.value.onlyQR"></div>

      <!-- ¿QUIERE DAR LA BAJA EN QR? -->
      <h4 class="subheading-01-semi-bold">
        ¿Desea {{ this.value.onlyQR ? "" : "también " }} dar la baja de
        {{ agentFullName }} en QR?
      </h4>

      <!-- ERRORES Y WARNING AL QUERER DAR LA BAJA QR -->
      <div class="cant-disabled-remove-QR">
        <!-- ERROR: NO SE PUEDE DAR DE BAJA 
             PERTENECE A TEAM (AR-PY-EC-GL) O TIENE RESERVAS EN NEG/CONFORMADO (EC)-->
        <p
          class="msg-error-disabled-agent subheading-01-semi-bold"
          *ngIf="
            this.errorsRemoveQR[0].error ||
            (NODE === NODE_EC && this.errorsRemoveQR[1].error)
          "
        >
          {{ canBeDisabledMsg }}
        </p>
        <div
          class="buttons link"
          *ngIf="NODE === NODE_EC && this.errorsRemoveQR[1].error"
        >
          <qr-button
            [config]="buttonGoToReservations"
            (click)="goToReservations()"
          ></qr-button>
        </div>
        <div class="buttons closeQR" *ngIf="this.errorsRemoveQR[0].error">
          <qr-button
            [config]="buttonCancelWantToRemoveQR"
            (click)="closeModal()"
          ></qr-button>
        </div>
      </div>

      <!-- FORMULARIO BAJA QR  -->
      <ng-container *ngIf="!isDateHide">
        <div class="removal-qr">
          <div class="date">
            <span class="subheading-01-semi-bold">Fecha de baja</span>
            <qr-date-picker
              class="date-picker"
              [config]="datePicker"
              (datepickerChange)="datepickerChange($event)"
              [hasError]="errorDateInput"
            ></qr-date-picker>
            <div class="error caption-01-regular" *ngIf="this.errorDateInput">
              La fecha no puede ser mayor a hoy
            </div>
          </div>
        </div>
        <div class="buttons">
          <qr-button
            [config]="buttonCancelWantToRemoveQR"
            (click)="closeModal()"
          ></qr-button>
          <qr-button
            [config]="buttonWantToRemoveQR"
            (click)="onCheckAgentRemoveQR()"
            [isDisabled]="this.errorDateInput"
          ></qr-button>
        </div>
      </ng-container>
    </div>
    <!-- SUCCESS BAJA QR ✅ -->
    <ng-container *ngIf="successAgentRemoveQR">
      <div class="line" *ngIf="!this.value.onlyQR"></div>
      <div class="success-remove">
        <div class="sign-success">
          <qr-icon name="check" color="success-500"></qr-icon>
          <span class="subheading-01-semi-bold"
            >Se ha dado de baja correctamente al agente {{ agentFullName }} en
            QR</span
          >
        </div>
      </div>
    </ng-container>

    <!-- WARNING: TIENE CAPTACIONES ACTIVAS -->
    <div
      class="container-error-captaciones-activas"
      *ngIf="showActiveCaptationsError()"
    >
      <h3 class="subheading-01-semi-bold">
        <qr-icon name="error" color="warning-500"></qr-icon>
        <span>Atención: El agente dispone de captaciones activas.</span>
      </h3>

      <div class="buttons">
        <qr-button
          [config]="buttonCancelCaptaciones"
          (click)="inactivarCaptaciones(0)"
        ></qr-button>
        <qr-button
          [config]="buttonAceptCaptaciones"
          (click)="inactivarCaptaciones(1)"
        ></qr-button>
      </div>
    </div>

    <!-- WARNING: TIENE RESERVAS ACTIVAS - NUEVO FLUJO DE BAJA - (AR - GL - PY) -->
    <div
      class="container-error-captaciones-activas"
      *ngIf="
        this.errorsRemoveQR[1].error &&
        !hideCaptacionesActivas &&
        !successAgentRemoveQR &&
        NODE !== NODE_EC
      "
    >
      <h3 class="subheading-01-semi-bold">
        <qr-icon name="error" color="warning-500"></qr-icon>
        <span>{{ canBeDisabledMsg }}</span>
      </h3>

      <h4 class="subheading-01-semi-bold">
        El agente tiene estas reservas en negociación y conformado:
      </h4>
      <div class="container-reservations">
        <div *ngFor="let reservation of reservations" class="reservations">
          <p class="paragraph-02-bold date">
            {{ reservation.reservationDate }}
          </p>
          <p class="paragraph-02-bold date">({{ reservation.state }})</p>
          <p class="paragraph-02-bold address">
            {{ this.utilsService.truncateString(reservation.address, 35) }}
          </p>
        </div>
      </div>
      <p class="subheading-01-semi-bold reserva">
        *Las reservas se reflejarán en el reservómetro con estos estados.
      </p>

      <div class="buttons">
        <qr-button
          [config]="buttonCancelBaja"
          (click)="inactivarCaptaciones(0)"
        ></qr-button>
        <qr-button
          [config]="buttonWantToRemoveQR"
          (click)="onAgentRemoveQR()"
        ></qr-button>
      </div>
    </div>
  </div>
</div>

<!-- LOADING GLOBAL -->
<div class="loading" *ngIf="isLoading">
  <p class="subheading-01-semi-bold">Validando...</p>
  <div class="line-loading"></div>
</div>

<!-- LOADING FIXED NO CLICKS. -->
<div class="priority-loading" *ngIf="isLoadingRestrictive">
  <div class="loading">
    <p class="subheading-01-semi-bold">Validando...</p>
    <div class="line-loading"></div>
  </div>
</div>
